import { inject, input, viewChild } from '@angular/core';
import { CAP_GAINS_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
function CapitalGainsFeatureCheckComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 3);
    i0.ɵɵlistener("click", function CapitalGainsFeatureCheckComponent_Conditional_0_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.openFeatureNeededModal()); });
    i0.ɵɵtext(5, "Start Trial");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("View ", ctx_r1.title());
} }
export class CapitalGainsFeatureCheckComponent {
    constructor() {
        this.featureNeededComponent = viewChild.required(FeatureNeededComponent);
        this.title = input('Capital Gains', ...(ngDevMode ? [{ debugName: "title" }] : []));
        this._featureService = inject(FeatureService);
        this.show = !this._featureService.userHasFeatures([CAP_GAINS_FEATURE]);
    }
    openFeatureNeededModal() {
        this.featureNeededComponent().openModal(CAP_GAINS_FEATURE);
    }
}
CapitalGainsFeatureCheckComponent.ɵfac = function CapitalGainsFeatureCheckComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CapitalGainsFeatureCheckComponent)(); };
CapitalGainsFeatureCheckComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CapitalGainsFeatureCheckComponent, selectors: [["ycn-capital-gains-feature-check"]], viewQuery: function CapitalGainsFeatureCheckComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.featureNeededComponent, FeatureNeededComponent, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance();
    } }, inputs: { title: [1, "title"] }, decls: 2, vars: 1, consts: [[1, "panel-locked-message"], [1, "panel-locked-message-wrap"], [1, "mb-row"], ["type", "button", 1, "btn", "btn-primary", "btn-support", 3, "click"]], template: function CapitalGainsFeatureCheckComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, CapitalGainsFeatureCheckComponent_Conditional_0_Template, 6, 1, "div", 0);
        i0.ɵɵelement(1, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.show ? 0 : -1);
    } }, dependencies: [FeatureNeededModule, i1.FeatureNeededComponent], encapsulation: 2 });
